export default interface Host {
    deviceHostId: string
    host: string
    port: string
    organizationId: number,
    protocol: string,
    identificationHost: string,
    context: string
}

export const colorHostStatus = [
    { name: 'initial', value: 'Icon__InitialStatus' }, // #0062ad
    { name: 'startingTest', value: 'Icon__StartingTest' }, //#7f85a4
    { name: 'success', value: 'Icon__Success'}, //#59c606
    { name: 'timeOut', value: 'Icon__TimeOut' }, //#ed2132
]
